import styled from '@emotion/styled';
import Button from '../../components/button';
import Icon from '../../components/icon';
import theme from '../../theme';

export const CropperContainer = styled('div')`
  position: relative;
  width: 250px;
  height: 167px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.palette.border.primary};

  @media (min-width: ${theme.breakpoints.values.sm}) {
    width: 500px;
    height: 332px;
  }

  .cropArea {
    border: 1px solid ${theme.palette.border.primary};
  }
`;

export const CropperActions = styled('div')`
  margin-top: ${theme.spacing(1)};
`;

export const ButtonWithMargin = styled(Button)`
  margin-left: ${theme.spacing(0.5)};
`;

export const MirroredIcon = styled(Icon)`
  transform: scale(-1, 1);
`;
